import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../../services/spinner.service';
import { DocumentoInteresControllerService, } from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { DownloadService } from '../../../services/download.service';

@Component({
  selector: 'lib-holders-cvf-image-detail',
  templateUrl: './holders-cvf-image-detail.component.html',
  styleUrls: ['./holders-cvf-image-detail.component.scss']
})
export class HoldersCvfImageDetailComponent implements OnInit {

  scale: number = 3.5;
  minScale: number = 1.6;
  maxScale: number = 5;
  readonly scaleStep = 0.5;
  isPoseedor: boolean = false;


  constructor(
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private documentoInteresService: DocumentoInteresControllerService,
    private dialogRef: MatDialogRef<HoldersCvfImageDetailComponent>,
    private snackBarSrv: SnackbarService,
    private downloadService: DownloadService,
    @Inject(MAT_DIALOG_DATA) public data: { isPoseedor: boolean }
  ) {
    if (this.data && this.data.isPoseedor !== undefined) {
      this.isPoseedor = this.data.isPoseedor;
      if (this.isPoseedor) {
        this.scale = 6;
        this.maxScale = 7.5;
        this.minScale = 4.1;
      }
    }
  }

  ngOnInit() {

  }

  closeDialog(): void {
    this.dialogRef.close();
  }


  zoomIn(): void {
    if (this.scale < this.maxScale) this.scale += this.scaleStep;
  }

  zoomOut(): void {
    if (this.scale > this.minScale) this.scale -= this.scaleStep;
  }

  resetZoom(): void {
    if(this.isPoseedor) {
      this.scale = 6  ;
    } else {
      this.scale = 3.5;
    }
  }

  descargaAyuda(){
    this.spinnerSrv.loadingShow();
    if (this.isPoseedor) {
      this.documentoInteresService.descargarDocumentoInteres('AyudaCVFPoseedores').subscribe({
        next: (response: any) => {
          this.downloadService.downloadBlob(response as any, 'AyudaCVFPoseedores.pdf');
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha descargado la ayuda correctamente',
            'success'
          );
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al descargar la ayuda',
            'error'
          );
        }
      });
    } else if(!this.isPoseedor){
      this.documentoInteresService.descargarDocumentoInteres('AyudaCVFGestores').subscribe({
        next: (response: any) => {
          this.downloadService.downloadBlob(response as any, 'AyudaCVFGestores.pdf');
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha descargado la ayuda correctamente',
            'success'
          );
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al descargar la ayuda',
            'error'
          );
        }
      });
    }
  }
}
